import styled from 'styled-components';
import Image from '@stencil/image';
import Button from '../../../../core-components/Button/Button';
import {props} from '../WhatToKnow/mock/WhatToKnowMock';

export const Container = styled.div`
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  text-align: center;
  font-family: Arial, sans-serif;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  height: 384px;
`;

export const ImageContainer = styled.div`
  margin-bottom: 20px;
`;

export const ImageWrapper = styled(Image)`
  width: 200px;
  margin: 10px 55px;
`;

export const Description = styled.div`
  font-size: ${props => props.theme.font.custom(15)};
  color: ${props => props.theme.colors.black.base};
  margin-bottom: 20px;
`;

export const ButtonWrapper = styled(Button)`
  width: 100%;
  margin: 0;
  font-size: ${props => props.theme.font.custom(16)};
`;
